import React, { useEffect, useState } from "react";

const DEFAULT_ANDROID_DOWNLOAD = "https://h5coml.vivo.com.cn/h5coml/appdetail_h5/browser_v2/index.html?appId=3722970";

export default function AndroidDownloadRedirect() {
  const [androidDownload, setAndroidDownload] = useState(DEFAULT_ANDROID_DOWNLOAD);

  useEffect(() => {
    fetch('https://www.10055.net/hopeapi/config/setting')
      .then(res => res.json())
      .then(data => {
        const found = data?.data?.find(item => item.configKey === 'txsc_h5_dl_android_m_link');
        if (found && found.configValue) {
          setAndroidDownload(found.configValue);
          window.location.replace(found.configValue);
        } else {
          window.location.replace(DEFAULT_ANDROID_DOWNLOAD);
        }
      })
      .catch(() => {
        window.location.replace(DEFAULT_ANDROID_DOWNLOAD);
      });
  }, []);

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', fontFamily: 'Segoe UI, Arial, sans-serif', color: '#222'
    }}>
      <div style={{
        background: '#fff', borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', padding: '32px 24px', maxWidth: '360px', width: '100%', textAlign: 'center'
      }}>
        <div style={{ fontSize: '1.2rem', fontWeight: 600, color: '#2d5be3', marginBottom: '16px' }}>正在跳转到下载页面...</div>
        <div style={{ fontSize: '1rem', color: '#444' }}>
          如果没有自动跳转，<a href={androidDownload} style={{ color: '#2d5be3', textDecoration: 'underline' }}>请点击这里下载</a>
        </div>
      </div>
    </div>
  );
} 